<div class="content-wrapper table-full-bx details-page">
    <div class="page-content recruiterpanel">
        <div class="row">
            <div class="col-lg-12">
                <div class="ibox">
                    <div class="ibox-body">
                        <div class="page-heading">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><a routerLink="/users"> Users </a></li>
                                <li class="breadcrumb-item">{{titles}} User</li>
                            </ol>
                        </div>
                        <div class="ibox-title">
                            <span> {{titles}} User </span>
                        </div>
                        <div class="col-bx-top">
                            <form [formGroup]="usersForm" (ngSubmit)="submitUser()">
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <label>Full name<span class="text-orange">*</span> </label>
                                            <input class="form-control" type="text" placeholder="Mark Wood" formControlName="fullName" maxlength="50" appCapitalizeFirst />
                                            <div class="text-danger" *ngIf="usersForm.controls['fullName'].hasError('required') && showError">
                                                *Please enter full name.
                                            </div>
                                            <div class="text-danger" *ngIf="usersForm.controls['fullName'].hasError('minlength') && showError">
                                                *Minimum 3 characters required.
                                            </div>
                                            <div class="text-danger" *ngIf="usersForm.controls['fullName'].hasError('maxlength') && showError">
                                                *Maximum 50 characters required.
                                            </div>
                                            <div class="text-danger" *ngIf="usersForm.controls['fullName'].hasError('pattern') && showError">
                                                *Please enter only alphabets.
                                            </div>
                                            <div class="text-danger" 
                                                *ngIf="!usersForm.controls['fullName'].hasError('required') && 
                                                    !usersForm.controls['fullName'].hasError('minlength') && 
                                                    !usersForm.controls['fullName'].hasError('maxlength') && 
                                                    usersForm.controls['fullName'].hasError('cannotContainSpace') && showError">
                                                *Invalid characters.
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <label> Email<span class="text-orange">*</span> </label>
                                            <input class="form-control" type="text" placeholder="mark.05@gmail.com" formControlName="email" [readonly]="userID"/>
                                            <div class="text-danger" *ngIf="usersForm.controls['email'].hasError('required') && showError">
                                                *Please enter email.
                                            </div>
                                            <div class="text-danger" *ngIf="usersForm.controls['email'].hasError('pattern') && showError">
                                                *Please enter valid email.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <label> Phone number </label>
                                            <div  class="countryCode">
                                                <span><input type="text" class="form-control" readonly placeholder="(+1)" ></span>
                                                <input class="form-control" type="text" placeholder="4546787543" formControlName="phoneNumber"  maxlength="10"/>
                                                <!-- mask="0000-000-000" -->
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <label> Title<span class="text-orange">*</span> </label>
                                            <input class="form-control" type="text" placeholder="Account Manager" formControlName="title" maxlength="50" appCapitalizeFirst/>
                                            <div class="text-danger" *ngIf="usersForm.controls['title'].hasError('required') && showError">
                                                *Please enter title.
                                            </div>
                                            <div class="text-danger" *ngIf="usersForm.controls['title'].hasError('minlength') && showError">
                                                *Minimum 3 characters required.
                                            </div>
                                            <div class="text-danger" *ngIf="usersForm.controls['title'].hasError('maxlength') && showError">
                                                *Maximum 50 characters required.
                                            </div>
                                            <div class="text-danger" *ngIf="usersForm.controls['title'].hasError('pattern') && showError">
                                                *Please enter only alphabets.
                                            </div>
                                            <div class="text-danger" 
                                                *ngIf="!usersForm.controls['title'].hasError('required') && 
                                                    !usersForm.controls['title'].hasError('minlength') && 
                                                    !usersForm.controls['title'].hasError('maxlength') && 
                                                    usersForm.controls['title'].hasError('cannotContainSpace') && showError">
                                                *Invalid characters.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <label> LinkedIn </label>
                                            <input class="form-control" type="text" placeholder="https://www.linkedin.com/in/markwwod-3" formControlName="linkedin" />
                                            <div class="text-danger" *ngIf="usersForm.controls['linkedin'].hasError('pattern') && showError">
                                                *Please enter valid linkedin eg. https://www.linkedin.com.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <label class=""> Assign a group <span class="text-orange">*</span> </label>
                                            <ng-multiselect-dropdown 
                                                formControlName="assignGroupIds"
                                                class="form-control noBorder px-0" 
                                                [placeholder]="'Select'" 
                                                [settings]="dropdownSettings"  
                                                [data]="allGroup" 
                                                (onSelect)="onItemSelect($event)" 
                                                (onDeSelect)="onItemDeSelect($event)" 
                                                >
                                            </ng-multiselect-dropdown>
                                            <div class="text-danger" *ngIf="usersForm.controls['assignGroupIds'].hasError('required') && showError">
                                                *Please select assign group.
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="add-permissions">
                                    <div class="ibox-title">
                                        <span> Permissions </span>
                                    </div>

                                    <div class="jobswrap" *ngFor="let access of accessList; let i=index">
                                        <h6 class="sub_title"> {{access?.name}} </h6>
                                        <div class="row">
                                            <div class="col-lg-6" *ngFor="let acc of access?.placeholder; let j = index">
                                                <div class="checkboxWrap" (click)="clickEvent(i,j)">
                                                    <input type="checkbox" 
                                                    [checked]="acc?.permission == 1 ? true : false"
                                                     /> 
                                                    <label for="jobs1">{{acc.title}}</label>
                                                </div>
                                            </div>
                                         </div>
                                    </div>

                                </div>

                                <div class="form-group btnwrap">
                                    <input value="Cancel" name="" class="common-btn unfill" type="submit" routerLink="/users"/>
                                    <input value="{{titles == 'Add' ? 'Add' : 'Update'}} User" name="" class="common-btn" type="submit"/>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>